import "@perxis-auto/shared";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "@perxis-auto/shared/lib";
import { formatVehicleDescription } from "../../../shared/lib/format/vehicle/formatVehicleDescription.js";
import { formatVehicleTitle } from "../../../shared/lib/format/vehicle/formatVehicleTitle.js";
import "../../../shared/lib/logger/index.js";
const GET_DEFAULT_CONTAINER_PROPS = () => ({
  formatVehicleDescription,
  formatVehicleTitle
});
export {
  GET_DEFAULT_CONTAINER_PROPS
};
